import React from "react";
import NavUp from "../../commons/NavUp";
import "./Component/Card.css";
import Card from "./Component/Card";
import firebaseManager from "../../model/Firebase/FirebaseManager";
import Title from "../Login/Components/title/title";
import NavbarDownConsumer from "../../commons/NavbarDownConsumer";
import { Link } from "react-router-dom";

class Home extends React.Component {
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor(props) {
    super();
    this.state = {
      dents: [],
    };

    this.getDentuser();
  }

  getDentuser() {
    firebaseManager.getDentInfoForCurrentUser(this.getDentIdsCallback);
  }

  getDentIdsCallback = (dentIds) => {
    if (dentIds) {
      dentIds.map((dentId) => {
        return firebaseManager.getDentInfoForCard(
          dentId,
          this.dentInfoCallback
        );
      });
    }
  };

  dentInfoCallback = (dentInfo) => {
    this.setState({
      dents: this.state.dents.concat([dentInfo]),
    });
    let repairs = document.getElementById("repairs");
    let noRepairs = document.getElementById("noRepairs");

    repairs.classList.remove("d-none");
    noRepairs.classList.add("d-none");
  };

  handlePayment() {
    window.location = "/payment";
  }

  selectNewTime() {
    window.location = "/new_time";
  }

  render() {
    const reload = () => {
      window.location.reload();
    };

    return (
      <React.Fragment>
        <NavUp />
        <div id="repairs" className="d-none">
          <Title text1="Your repairs." />
        </div>
        <div id="noRepairs" className="">
          <Title text1="You haven't repairs." />
        </div>
        <div id="btnCard" className="text-center">
          {this.state.dents.map((dentInfo) => (
            <Card key={dentInfo.dent_id} dentInfo={dentInfo} />
          ))}
        </div>
        <div id="datos"></div>

        <div className="text-center">
          <button
            onClick={this.selectNewTime}
            id="btnChangeTime"
            className="btn btn-secondary mx-auto mt-2 mb-2 d-none"
          >
            Select a new time
          </button>
        </div>   
        <div className="text-center mb-5">
          <button
            onClick={reload}
            id="btnHome"
            className="btn btn-secondary mx-auto mt-2 mb-5 d-none"
          >
            Back to home
          </button>
        </div>
        <div className="text-center mb-5">
          <Link to="car_info">
            <button id="btnAdd" className="btn btn-secondary mb-5">
              Add new dent
            </button>
          </Link>
        </div>
        <NavbarDownConsumer />
      </React.Fragment>
    );
  }
}
export default Home;
